import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { joiResolver } from '@hookform/resolvers/joi';

import { useAppContext } from '../../../app/Context';
import { login } from '../../../db/auth';
import { NextScreen } from '../../../db/auth/types';
import routes from '../../../routes/router';
import { useAuthContext } from '../Context';
import { AuthScreen } from '../types';
import { FormValues } from './types';
import { validationSchema } from './validators';
import { getLocalData } from '../../../db/local-storage';
import { setUserId } from '../../../db/session';
import { getUrl } from '../../../db/shared';

const useLoginPasswordVM = () => {
  const navigate = useNavigate();
  const { presentationId, activeSlideId, session, setSession, setError: setAppError } = useAppContext();
  const { setScreen } = useAuthContext();

  const formMethods = useForm<FormValues>({
    defaultValues: {
      password: '',
    },
    resolver: joiResolver(validationSchema),
    mode: 'all',
  });

  const { setError } = formMethods;

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    if (!presentationId) return;
    if (!activeSlideId) return;

    if (!session) return;

    const response = await login({ userId: session.userId, password: data.password });

    if (response.isSuccess === false) {
      const { message, next } = response;

      if (next === NextScreen.PPT_PLUGIN_NOT_ACCESSIBLE) {
        setAppError(message);
        return;
      }

      setError('password', { message });
      return;
    }

    const { next, socket, token } = response;

    await getLocalData({ presentationId }, token);

    setSession({ ...session, socket, token });
    setUserId(session.userId);

    switch (next) {
      case NextScreen.LANDING_PAGE:
        const url = getUrl(presentationId, activeSlideId) ?? routes.home.url();
        navigate(url, { replace: true });
        /**
         * after redux session has been set,
         * user will automatically redirect to home page
         */
        break;
      default:
        break;
    }
  };

  const handleBack = () => {
    setScreen(AuthScreen.LOGIN);
  };

  const acadlySignupUrl = `${process.env.REACT_APP_ACADLY_WEB_URL}${routes.DO_NOT_USE_ACADLY_SIGN_UP.acadlyWebUrl()}`;

  return {
    formMethods,
    onSubmit,
    handleBack,
    session,
    acadlySignupUrl,
  };
};

export default useLoginPasswordVM;
